<template>
  <div>
    <div ref="firebase-auth-loggedin" v-if="isKnownUser">
      <md-button @click="signOut">uitloggen</md-button>
    </div>
    <div ref="firebase-auth-signedout" v-show="!isKnownUser">
      <div ref="firebaseuiAuthContainer"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { authUi } from "../../init/firebase.init";
import authUiConfig from "../../config/authuiconfig";

import { navigate, translate, googleTags } from "../../mixins";
/* eslint no-debugger: 0 */
export default {
  name: "Authenticate",
  mixins: [navigate, translate, googleTags],
  props: { bindAuthUi: { type: Boolean } },
  mounted() {
    // The start method will wait until the DOM is loaded.
    authUi.start(this.$refs.firebaseuiAuthContainer, authUiConfig);
    this.gTagScreenView("Account");
  },
  data() {
    return {
      menuVisible: false,
      checkDeletion: false
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["isKnownUser"])
  },
  methods: {
    signOut() {
      this.$store.dispatch("logout");
    },
    cancelDeletionHandle() {
      this.checkDeletion = false;
    },
    confirmDeletionHandle() {
      this.$store.dispatch("deleteUser").then(() => this.$store.dispatch("logout").then(() => this.gTagEvent("reset_data")));
    }
  },
  watch: {
    bindAuthUi() {
      debugger;
      if (this.bindAuthUi) {
        authUi.start(this.$refs.firebaseuiAuthContainer, authUiConfig);
      }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.c-login {
  width: 100%;
  max-width: 375px;
  margin: 0 auto;
}

h1 {
  font-family: "Rajdhani", "Roboto", sans-serif;
  font-size: 3rem;
  font-weight: 300;
  margin-top: 0;
}

h2 {
  font-family: "Dawning of a New Day", cursive;
  font-size: 2rem;
  text-align: right;
}
p {
  padding: 0 16px;
}

.md-content .md-button:last-of-type {
  margin-bottom: 100px;
}

::v-deep .firebaseui-card-content {
  padding: 0;
}

::v-deep .firebaseui-idp-list {
  margin-top: 0;
}
</style>
